<div class="full-vh-container">

  <mat-card>
    <div class="panel__header">
      <span class="panel__header__title">{{'UC planner' | translate | async}}</span>
    </div>
    <div class="row ">
      <div class="col-lg-12">

        <mat-form-field class="col-lg-4">
          <input matInput #customerAutoCompleteInput (focus)="focus(1)" placeholder="{{'Customer' | translate | async}}" aria-label="customer"
            [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
          <mat-autocomplete #autoCustomer="matAutocomplete"
            (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
            <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
              <span>{{ customer.Title }}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col-lg-4">

          <input matInput (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder="{{'JobSite' | translate | async}}" aria-label="jobsite"
            [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">

          <!-- [displayWith]="jobsiteDisplayMapper" -->
          <mat-autocomplete #autoJobsite="matAutocomplete"
            (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
            <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
              <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
              <span>{{ jobsite.Title }}</span>
              <small></small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col-lg-4">

          <input matInput (focus)="focus(4)" #familyAutoCompleteInput placeholder="{{'Family' | translate | async}}"
            aria-label="Family" [matAutocomplete]="autoFamily" [formControl]="familyCtrl">

          <mat-autocomplete #autoFamily="matAutocomplete"
            (optionSelected)="familySelected($event,familyAutoCompleteInput)">
            <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
              <span>{{ family.Title }}</span> |
              <small>{{family.Symbol}}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field class="col-lg-4">

          <input matInput (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{'Make' | translate | async}}"
            aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">

          <mat-autocomplete #autoMake="matAutocomplete" (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
            <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
              <span>{{ make.Title }}</span> |
              <small>{{make.Symbol}}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="col-lg-4">
          <mat-chip-list #modelChipList>
            <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(6)" [selectable]="false"
              [removable]="true" (removed)="popMultipleSelection(6, item.SearchId, item.SearchStr)">
              {{item.Title}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input matInput [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false" (focus)="focus(6)" #modelAutoCompleteInput
              placeholder="{{ Translate('Model')}}" aria-label="Model" [matAutocomplete]="autoModel"
              [formControl]="modelCtrl">
          </mat-chip-list>
          <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="modelDisplayMapper"
            (optionSelected)="modelSelected($event,modelAutoCompleteInput)">
            <mat-option *ngFor="let model of filteredModels | async" [value]="model">
              <span>{{ model.Title }}</span>
              <small></small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

  </mat-card>


  <div class="table-row">
    <div class="flex columns div-margin-top " [@enterAnimation]>
      <div class="panel panel--tasks" style="flex-shrink: 0.1;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Display options' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button" (click)="DisplaySettingsPopup(5)">
            <i class="material-icons square-button__icon"
              title="Update user settings to advanced user to access other tasks">view_timeline</i>
            <span class="square-button__label">{{'Interval' | translate | async}}</span>
          </a>

          <a class="square-button" (click)="DisplaySettingsPopup(4)">
            <i class="material-icons square-button__icon">settings</i>
            <span class="square-button__label"> {{'Components' | translate | async}}</span>
          </a>

          <a class="square-button" (click)="DisplaySettingsPopup(1)">
            <i class="material-icons square-button__icon">bar_chart</i>
            <span class="square-button__label"> {{'Columns' | translate | async}}</span>
          </a>

          <a class="square-button" (click)="DisplaySettingsPopup(2)">
            <i class="material-icons square-button__icon">date_range</i>
            <span class="square-button__label"> {{'Dates' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="DisplaySettingsPopup(3)">
            <i class="material-icons square-button__icon">pending_actions</i>
            <span class="square-button__label">{{'Legend' | translate | async}}</span>
          </a>
        </div>
      </div>

      <div class="panel panel--next-inspection" style="flex-shrink:0.1;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Tasks' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">

          <a class="square-button" style="margin-right: 20px;" (click)="NavigateToSearch(1)">
            <i class="material-icons square-button__icon">task</i>
            <span class="square-button__label">{{'Enter SMU/Dates' | translate | async}}</span>
          </a>

          <a class="square-button" style="margin-right: 20px;">
            <i class="material-icons square-button__icon" (click)="DisplaySettingsPopup(8)"
              style="transform: rotateY(0deg) rotate(45deg);">check_box_outline_blank</i>
            <span class="square-button__label">{{'Actions' | translate | async}}</span>
          </a>

          <a class="square-button" (click)="NavigateToSearch(2)">
            <i class="material-icons square-button__icon">search</i>
            <span class="square-button__label">{{'Action Search' | translate | async}}</span>
          </a>

        </div>
      </div>

      <div class="panel panel--inspections" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
             {{'Favorites' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button" (click)="DisplaySettingsPopup(6)">
            <i class="material-icons square-button__icon">favorite</i>
            <span class="square-button__label">{{'Create Favorite' | translate | async}}</span>
          </a>

          <ng-container *ngFor="let favorite of userFavorites" class="favourites">
            <a class="square-button" [ngStyle]="{'background-color':favorite.BackgroundColor}">
              <span class="square-button__label" [ngStyle]="{'color':favorite.TextColor}"
                (click)="getFavorite(favorite.Id)" style="margin-top: 15px;font-size: 16px;">{{favorite.Name}}</span>
              <i class="material-icons button__icon" [ngStyle]="{'color':favorite.TextColor}"
                matTooltip="Edit Favourite" [matMenuTriggerFor]="menu" style="transform: rotate(90deg);">more_vert</i>
            </a>
            <mat-menu #menu="matMenu">

              <button mat-menu-item (click)="DisplaySettingsPopup(15,favorite)">
                <mat-icon>edit</mat-icon>
                <span>{{'Update to Current Selection' | translate | async}}</span>
              </button>
              <button mat-menu-item (click)="DisplaySettingsPopup(16,favorite)">
                <mat-icon>delete_forever</mat-icon>
                <span>{{'Delete' | translate | async}}</span>
              </button>
            </mat-menu>
          </ng-container>
        </div>
      </div>

      <div class="panel panel--download" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Download' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button">
            <i class="material-icons square-button__icon" style="margin-top: 8px;"
              (click)="exportCSVClicked()">download</i>
            <span class="square-button__label"></span>
          </a>
        </div>
      </div>

      <div class="panel panel--inspections" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Preparing Planner' | translate | async}}
          </span>
        </div>
        <div class="flex flex--align-stretch" style="margin-top:40px;flex-direction: row-reverse;">
          <button mat-raised-button color="warn" (click)="GenerateData()" style="margin-left: 20px;margin-right: 20px;">
            {{'Generate' | translate | async}}
          </button>
          <button mat-raised-button (click)="resetFields()"> Reset </button>


        </div>
      </div>
    </div>

    <mat-card class="mat-card">
      <div style="text-align: center;margin-left:50%">
        <mat-spinner *ngIf="FleetTableLoader" class=""></mat-spinner>
      </div>
    </mat-card>
  </div>
  <div class="uc-table-wrap">
    <div class="table-container">
      <div class="component-table-container component-table">
        <!-- <table class="table table--full-width table--striped"> -->
        <table class="table table--full-width component-table" *ngIf="IsTableShow">
          <thead>
            <tr class="table-row th-row">
              <th></th>
              <th *ngIf="ColumnList.Make">Make</th>
              <th>Model</th>
              <th>Unit</th>
              <th>SMU</th>
              <th>Distance ({{userUOD}}) </th>
              <th *ngIf="ColumnList.LastInspection">Last <br>Inspect.<br> Worn % </th>
              <th *ngIf="ColumnList.Position">% Worn <br>Today</th>
              <th *ngIf="ColumnList.NextPmService">Next Pm<br>Service</th>
              <th *ngIf="ColumnList.SecondPmService">2nd Pm<br>Service</th>
              <th *ngIf="ColumnList.Worn_100">100 % <br>Worn</th>
              <th *ngIf="ColumnList.Worn_120">120 % <br>Worn</th>
            </tr>
            <tr class="th-row" *ngIf="intervel==1">
              <th></th>
              <th *ngIf="ColumnList.Make"></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th *ngIf="ColumnList.LastInspection"></th>
              <th *ngIf="ColumnList.Position"></th>
              <th *ngIf="ColumnList.NextPmService"></th>
              <th *ngIf="ColumnList.SecondPmService"></th>
              <th *ngIf="ColumnList.Worn_100"></th>
              <th *ngIf="ColumnList.Worn_120"></th>

            </tr>
            <!-- <tr style="height: 49px;" *ngIf="intervel==1" >
            <th></th>
            <th *ngIf="ColumnList.Make"></th>
            <th></th>
            <th></th>
            <th></th>
            <th> </th>
            <th *ngIf="ColumnList.LastInspection"></th>
            <th *ngIf="ColumnList.Position"></th>
            <th *ngIf="ColumnList.NextPmService"></th>
            <th *ngIf="ColumnList.SecondPmService"></th>
            <th *ngIf="ColumnList.Worn_100"></th>
            <th *ngIf="ColumnList.Worn_120"></th>
          </tr> -->
            <tr *ngIf="intervel==1">
              <td></td>
              <td *ngIf="ColumnList.Make"></td>
              <td></td>
              <td></td>
              <td></td>
              <td> </td>
              <td *ngIf="ColumnList.LastInspection"></td>
              <td *ngIf="ColumnList.Position"></td>
              <td *ngIf="ColumnList.NextPmService"></td>
              <td *ngIf="ColumnList.SecondPmService"></td>
              <td *ngIf="ColumnList.Worn_100"></td>
              <td *ngIf="ColumnList.Worn_120"></td>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through your items -->
            <ng-container *ngFor="let item of ucFleetEquipmentDetail">
              <!-- Main row: click toggles expansion -->
              <tr class="table-row-style">
                <td>
                  <a *ngIf="!item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                    <i class="material-icons square-button__icon">add</i>
                  </a>
                  <a *ngIf="item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                    <i class="material-icons square-button__icon">remove</i>
                  </a>
                </td>

                <td *ngIf="ColumnList.Make">{{ item.Make }}</td>
                <td style="text-align: center;">{{ item.Model }}</td>
                <td>{{ item.Unit }}</td>
                <td>{{ item.SMU }}</td>
                <td>{{ convertDistanceKmToMi(item.LTD) }}</td>

                <td *ngIf="ColumnList.LastInspection">{{item.LastPmDate |date: 'dd MMM yyyy' }}<br>{{item.LastPmSMU |
                  number: '1.0-0'}}<br>{{item.LastPmDOE | number: '1.0-0'}}</td>
                <td *ngIf="ColumnList.Position">{{item.TodayDate |date: 'dd MMM yyyy'}}<br>{{item.TodaySMU| number:
                  '1.0-0'}}<br>{{item.TodayDOE | number: '1.0-0'}}</td>
                <td *ngIf="ColumnList.NextPmService">{{item.NextPmDate |date: 'dd MMM yyyy'}}<br>{{item.NextPmSMU|
                  number: '1.0-0'}}<br>{{item.NextPmDOE | number: '1.0-0'}}</td>
                <td *ngIf="ColumnList.SecondPmService"> {{item.SecondPmDate |date: 'dd MMM yyyy'}}<br>{{item.SecondPmSMU| number: '1.0-0'}}<br>{{item.SecondPmDOE | number: '1.0-0'}}</td>
                <td *ngIf="ColumnList.Worn_100"></td>
                <td *ngIf="ColumnList.Worn_120"><mat-icon (click)="OpenSettingForecast(item,item.LastInspectionId, item.Unit)">settings</mat-icon></td>
              </tr>
              <!-- <tr ></tr> -->
              <ng-container *ngIf="item.IsExpanded">
                <div style="text-align: center;margin-left:50%">
                  <mat-spinner *ngIf="componentLoader" class=""></mat-spinner>
                </div>
                <ng-container *ngFor="let item1 of item.UCPlannerComponent">
                  <!-- <tr style="height: 24px;">
                    <td></td>
                    <td *ngIf="ColumnList.Make"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td *ngIf="ColumnList.LastInspection"></td>
                    <td *ngIf="ColumnList.Position"></td>
                    <td *ngIf="ColumnList.NextPmService"></td>
                    <td *ngIf="ColumnList.SecondPmService"></td>
                    <td *ngIf="ColumnList.Worn_100"></td>
                    <td *ngIf="ColumnList.Worn_120"></td>
                  </tr> -->
                  <ng-container
                    *ngIf="(item1.CompartTypeAuto==230 ||item1.CompartTypeAuto==231 ||item1.CompartTypeAuto==232) && HasSummaryTrackRoller ">
                    <tr *ngIf="item1.GroupNumber==1">
                      <td></td>
                      <td *ngIf="ColumnList.Make"></td>
                      <td>{{ item1.SystemType }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td *ngIf="ColumnList.LastInspection">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnLastinspction)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnLastinspction | number:'1.1-1'}}%</div>
                        </span>
                      </td>
                      <td *ngIf="ColumnList.Position">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnToday)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnToday | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.NextPmService">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnNextPm)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnNextPm | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.SecondPmService">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnSecondPm)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnSecondPm | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.Worn_100"></td>
                      <td *ngIf="ColumnList.Worn_120"></td>
                    </tr>
                  </ng-container>
                  <ng-container
                    *ngIf="(item1.CompartTypeAuto==233 ||item1.CompartTypeAuto==234 ||item1.CompartTypeAuto==235 ||item1.CompartTypeAuto==236) && HasSummaryRolling ">
                    <tr *ngIf="item1.GroupNumber==1">
                      <td></td>
                      <td *ngIf="ColumnList.Make"></td>
                      <td>{{ item1.SystemType }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td *ngIf="ColumnList.LastInspection">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnLastinspction)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnLastinspction | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.Position">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnToday)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnToday | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.NextPmService">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnNextPm)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnNextPm | number:'1.1-1' }}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.SecondPmService">
                        <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnSecondPm)"
                          style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                          <div style="text-align: -webkit-center !important ; display: inline-block;">
                            {{item1.WorstWornOnSecondPm | number:'1.1-1'}}%</div>

                        </span>
                      </td>
                      <td *ngIf="ColumnList.Worn_100"></td>
                      <td *ngIf="ColumnList.Worn_120"></td>
                    </tr>
                  </ng-container>
                  <tr style="height: 66px;">
                    <td></td>
                    <td *ngIf="ColumnList.Make"></td>
                    <td></td>
                    <td></td>
                    <td>{{ item1.CompartName }}</td>
                    <td></td>
                    <td *ngIf="ColumnList.LastInspection">
                      <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.LastInspectionWorn)"
                        style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                        <div style="text-align: -webkit-center !important ; display: inline-block;">
                          {{item1.LastInspectionWorn | number:'1.1-1'}}%</div>
                      </span>
                      <!-- {{item1.LastInspectionSmu}}/{{item1.LastInspectionDoe}} -->
                      <span *ngIf="ColumnList.CMU">{{item1.LastInspectionSmu | number: '1.0-0'}} /</span><span
                        *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.LastInspectionDoe) |
                        number:'1.0-0'}}</span>
                    </td>
                    <td *ngIf="ColumnList.Position">
                      <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornPercentageToday)"
                        style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                        <div style="text-align: -webkit-center !important ; display: inline-block;">
                          {{item1.WornPercentageToday | number:'1.1-1'}}%</div>
                      </span>
                      <span *ngIf="ColumnList.CMU">{{item1.WornPercentageTodaySmu | number:'1.0-0'}}/</span><span
                        *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.WornPercentageTodayDoe) |
                        number:'1.0-0'}}</span>
                    </td>
                    <td *ngIf="ColumnList.NextPmService">
                      <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtNextPmService)"
                        style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                        <div style="text-align: -webkit-center !important ; display: inline-block;">
                          {{item1.WornAtNextPmService | number:'1.1-1'}}%</div>

                      </span>
                      <span *ngIf="ColumnList.CMU">{{item1.SMUAtNextPm | number:'1.0-0'}}/</span> <span
                        *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtNextPm) | number:'1.0-0'}}</span>
                    </td>
                    <td *ngIf="ColumnList.SecondPmService">
                      <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtSecondPmService)"
                        style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                        <div style="text-align: -webkit-center !important ; display: inline-block;">
                          {{item1.WornAtSecondPmService | number:'1.1-1'}}%</div>

                      </span>
                      <span *ngIf="ColumnList.CMU">{{item1.SMUAtSecondPm}}/</span><span
                        *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtSecondPm)}}</span>
                    </td>
                    <td *ngIf="ColumnList.Worn_100">{{item1.DateAt100Worn |date: 'dd MMM yyyy'}}</td>
                    <td *ngIf="ColumnList.Worn_120">{{item1.DateAt120Worn |date: 'dd MMM yyyy'}}</td>

                  </tr>
                </ng-container>

                <!-- <ng-container *ngIf="!item.UCPlannerComponent?.length">
                <div class="no-data">No Component found.</div>
    
              </ng-container> -->
              </ng-container>
            </ng-container>

            <ng-container *ngIf="ucFleetEquipmentDetail.length === 0">
              <div class="no-data">No Equipment found.</div>

            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="hours-table">
        <table class="table table--full-width component-table" *ngIf="IsTableShow">

          <thead>
            <tr class="th-row">
              <th colspan="30" *ngFor="let month of uniqueMonths">
                <div style="display:flex; flex-direction: column;">
                  <div>{{month.MonthName}} {{month.YearNo}}</div>
                  <div>{{month.MonthlyBudget |currency:'USD':'symbol':'1.0-0'}}</div>
                </div>

              </th>
            </tr>
            <tr class="th-row " *ngIf="intervel==1">
              <th *ngFor="let item of GraphHeaderData" colspan="7" class="text-align week-border">{{ item.WeekStart |
                date: 'dd MMM' }} - {{
                item.WeekEnd | date: 'dd MMM' }} <br> <span style="text-align: center;"> {{ item.WeekNo }}</span>
                <br> <span style="text-align: center;"> {{ item.WeekLyBudget| currency:'USD':'symbol':'1.0-0' }}</span>

              </th>
            </tr>
            <tr class="table-row " *ngIf="intervel==1">
              <td style="height:66px;" *ngFor="let item of DaysArr"></td>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of ucFleetEquipmentDetail">
              <tr class="table-row-style" *ngIf="!item.IsExpanded">
                <td *ngFor="let day of DaysArr">
                  <div class="summary-align">
                    <span *ngIf="item.NextPmDays==day" class="circle green"></span>
                    <span *ngIf="item.NextPmDays==day">{{item.PM1ServiceTypeName}}</span>
                    <span *ngIf="item.SecondPmDays==day" class="circle green"></span>
                    <span *ngIf="item.SecondPmDays==day">{{item.PM2ServiceTypeName}}</span>
                  </div>

                  <ng-container *ngFor="let sum of item.Summary">
                    <div class="summary-align">
                      <span *ngIf="sum.ActionDateDays== day && sum!=null" class="circle blue"></span>
                      <!-- <div *ngIf="sum.ActionDateDays== day "  class="my-box always-hover"></div> -->
                      <div class="tooltip-container" *ngIf="sum.ActionDateDays== day " >
                        <span class="always-tooltip" *ngIf="sum.ActionCode">{{sum.ActionCode}}</span>
                      </div>
                      <span *ngIf="sum.ActionDateDays== day && sum.Price>0" class="circle pink"></span>
                      <span *ngIf="sum.ActionDateDays== day &&sum.Price>0">{{sum.Price | currency:'USD':'symbol':'1.0-0' }}</span>
                    </div>
                  </ng-container>
                </td>
              </tr>

              <tr class="table-row" *ngIf="intervel==1 && item.IsExpanded" style="height: 33px; border:none;">
                <th *ngFor="let weekly of item.Weekly" colspan="7" class="text-align">
                  {{weekly.TotalWeekPrice |currency:'USD':'symbol':'1.0-0'}}</th>
              </tr>
              <tr class="table-row" *ngIf="intervel==1 && item.IsExpanded" style="height: 33px;">

                <th *ngFor="let day of DaysArr" class="text-align" style=" font-weight: 400;">
                  <span *ngIf="item.NextPmDays==day">{{item.PM1ServiceTypeName}}1</span>
                  <span *ngIf="item.SecondPmDays==day">{{item.PM2ServiceTypeName}}2</span>
                </th>

              </tr>


              <ng-container *ngIf="item.IsExpanded">
                <div style="text-align: center;margin-left:50%">
                  <mat-spinner *ngIf="graphLoader" class=""></mat-spinner>
                </div>
                <ng-container *ngFor="let item1 of item.GraphData">
                  <ng-container
                    *ngIf="(item1.CompartTypeAuto==230 ||item1.CompartTypeAuto==231 ||item1.CompartTypeAuto==232) && HasSummaryTrackRoller ">
                    <tr *ngIf="item1.GroupNumber==1">
                      <td [attr.colspan]="TotalDays"></td>

                    </tr>
                  </ng-container>
                  <ng-container
                    *ngIf="(item1.CompartTypeAuto==233 ||item1.CompartTypeAuto==234 ||item1.CompartTypeAuto==235 ||item1.CompartTypeAuto==236) && HasSummaryRolling ">
                    <tr *ngIf="item1.GroupNumber==1">
                      <td [attr.colspan]="TotalDays"></td>

                    </tr>
                  </ng-container>
                  <tr style="height: 66px;">
                    <ng-container *ngFor="let day of DaysArr">
                      <td
                        [ngStyle]="{'border-right': 'none','padding': '0px','border-right': day === item1.TodayDateDays ? '2px solid red' : 'none'}">
                        <div class="bar-container">
                          <div [ngClass]="getBarClass(day, item1)">
                            <ng-container *ngFor="let day2 of item1.DaysForRecommArr">
                              <div *ngIf="day==day2.Days">
                                <mat-icon class="recom-Icon-color " style="position: relative;
                               bottom: -18px;left: -13px;" matTooltip="{{day2.Date|date: 'dd MMM yyyy'}}"
                                  (click)="DisplaySettingsPopup(112,'', day2.QuoteId,day2.Date,day2.ComponentId,item1.EquipmentId,day2.Smu)">navigation</mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isPopupVisible" class="popup-backdrop">
  <div class="popup-box">
    <h3>Custom Popup</h3>
    <p>This popup appears on button click!</p>
    <button (click)="closePopup()">Close</button>
  </div>
</div>